import { createSlice } from '@reduxjs/toolkit';

const campaignFormDirtySlice = createSlice({
  name: 'campaignFormDirty',
  initialState: {
    dirty: false,
    touched: [],
  },
  reducers: {
    setDirty: state => ({ ...state, dirty: true }),
    unsetDirty: state => ({ ...state, dirty: false }),
    setTouched: (state, { payload }) => ({
      ...state,
      touched: [...new Set([...state.touched, payload.field])],
    }),
    resetForm: state => ({ ...state, dirty: false, touched: [] }),
  },
});

export const {
  setDirty,
  unsetDirty,
  setTouched,
  resetForm,
} = campaignFormDirtySlice.actions;
export default campaignFormDirtySlice.reducer;
